export default __webpack_public_path__ + "static/media/money-back@3x.60222f37.png";